import { useLayoutEffect, useRef } from "react"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import "./spacer.component.css"

const SpacerComponent = (props) => {
  const { id, Size = "medium", InvertBackground } = props
  const elRef = useRef()

  useLayoutEffect(() => {
    if (!InvertBackground || !elRef.current) return

    const sibling = elRef.current.nextElementSibling
    if (!sibling) return

    const trigger = ScrollTrigger.create({
      trigger: sibling,
      start: "-160% top",
      onEnter: () => elRef.current?.classList.add("inverted"),
      onLeave: () => elRef.current?.classList.remove("inverted"),
      onLeaveBack: () => elRef.current?.classList.remove("inverted"),
      onEnterBack: () => elRef.current?.classList.add("inverted"),
    })

    return () => trigger.kill()
  }, [id, InvertBackground])

  return (
    <div
      ref={elRef}
      className={`dagger-spacer dagger-spacer-${Size} dagger-spacer-${id}`}
      aria-hidden="true"
    />
  )
}

export default SpacerComponent
